import {Component, OnInit} from '@angular/core';
import {ConfigService} from '../../../../services';
import {FormGroup} from '@angular/forms';
import {EmailTemplate} from '../../../../dto/templates/email-template';
import {InvoiceEmailTemplatesService} from '../../../services/invoice-email-templates.service';
import {OrderSource} from '../../../../dto/order-source';
import {MatSnackBar} from '@angular/material/snack-bar';
import {InvoicePaidConfig} from '../../../../dto/invoice-paid-config';


@Component( {
  selector: 'app-invoices-paid-configs',
  templateUrl: './invoices-paid-configs.component.html',
  styleUrls: [ './invoices-paid-configs.component.css' ]
} )
export class InvoicesPaidConfigsComponent implements OnInit {

  configs: InvoicePaidConfig[];
  orderSource = OrderSource;
  emailTemplates: EmailTemplate[];


  constructor(
    private snackBar: MatSnackBar,
    private configService: ConfigService,
    private emailTemplatesService: InvoiceEmailTemplatesService,
  ) {
  }

  configForm: FormGroup;

  ngOnInit() {
    this.emailTemplatesService.getMany().subscribe( result => {
      this.emailTemplates = result.data;

      this.configService.getInvoicesPaidConfigs().subscribe( data => {
        this.configs = data;
        console.log(data);
      } );

    } );
  }

  submit() {
    if ( this.findProblems() ) {
this.showMessage( 'Please, select required options for enabled Invoices or disable Invoices' );
} else {
this.configService.setInvoicesPaidConfigs( this.configs ).subscribe( result => {
 this.showMessage( result ); 
} );
}
  }

  showMessage( message ) {
    this.snackBar.open( message, null, {
      duration: 5000,
      panelClass: [ 'app-mat-snack-bar' ]
    } );
  }

  findProblems(): boolean {
    for ( let i = 0; i < this.configs.length; i++ ){
      if ( this.configs[ i ].enabled && ( this.configs[ i ].emailTemplateId == null ) ) {
return true;
}
    }//.forEach and for..in are not appropiate for this situation
    return false;
  }
}
